<div class="distribution-number-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup #addDistributionNumber [width]="600" [showTitle]="true" title="{{ modalTitle }}" [dragEnabled]="false"
    [closeOnOutsideClick]="false" [rtlEnabled]="rtlEnabled" [(visible)]="isOpened"
    (onShown)="onFieldDataChanged($event)">
    <dx-scroll-view width="100%" height="100%">
      <div class="au-dx-popup-padder">
        <dx-form #distributionNumberRangeForm id="distributionNumberForm" validationGroup="distributionNumberData" [showValidationSummary]="false"
                 (onFieldDataChanged)="onFieldDataChanged($event)" colCount="auto" [(formData)]="model" [minColWidth]="500">

          <dxi-item itemType="group">

            <dxi-item dataField="buyerId"
                        editorType="dxSelectBox"
                        [editorOptions]="{ 
                          dataSource: buyerLookupSource, 
                          valueExpr:'buyerId' ,
                          displayExpr: 'buyerDisplayValue', 
                          searchEnabled: 'true',
                          showClearButton: 'true', 
                          searchMode: 'contains',
                          searchExpr: 'buyerDisplayValue' }">
                <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.BUYER_NAME' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.BUYER_NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>

            <dxi-item dataField="masterDataListRowId"
                      editorType="dxSelectBox"
                      [editorOptions]="{ dataSource: masterDataLookupSource, valueExpr:'value' ,
                      displayExpr:'label', searchEnabled: 'true', showClearButton: 'true', searchExpr: 'label'}">
                <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }}"></dxo-label>
                <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.CATEGORY' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}"></dxi-validation-rule>
            </dxi-item>
            
            <dxi-item dataField="value" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1}">
              <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TITLE' | translate }}"></dxo-label>
              <dxi-validation-rule type="required" message="{{ 'DISTRIBUTION_MANAGEMENT.DISTRIBUTION_NUMBER_TITLE' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}">
              </dxi-validation-rule>
            </dxi-item>

            <dxi-item itemType="group" labelMode="hidden" *ngIf="isFixedNumbers">
              <dxo-label text="{{ 'DISTRIBUTION_MANAGEMENT.ACTIVE_DAYS' | translate }}"></dxo-label>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="mondayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.MONDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="monday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.mondayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="tuesdayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.TUESDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="tuesday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.tuesdayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="wednesdayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.WEDNESDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="wednesday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.wednesdayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="thursdayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.THURSDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="thursday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.thursdayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="fridayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.FRIDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="friday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.fridayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="saturdayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.SATURDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="saturday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.saturdayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group" colCount="6">
                <dxi-item dataField="sundayEnabled" editorType="dxCheckBox" (onValueChanged)="onDayEnabledChanged()">
                  <dxo-label location="right" text="{{ 'SHARED.SUNDAY' | translate }}"></dxo-label>
                </dxi-item>
                <dxi-item [colSpan]="3" dataField="sunday" editorType="dxNumberBox" [editorOptions]="{ format: '#', min: 0, step: 1, disabled: !model?.sundayEnabled }">
                  <dxo-label location="left" text="&nbsp;"></dxo-label>
                </dxi-item>
              </dxi-item>

            <dxi-item>
              <button type="button" class="btn btn-primary" (click)="generateNumber()" [disabled]="isGenerateDisabled">{{ 'DISTRIBUTION_MANAGEMENT.GENERATE' | translate }}</button>
            </dxi-item>
           </dxi-item>
          </dxi-item>
        </dx-form>
      <button type="submit" class="btn btn-primary" (click)="onSubmit();" name="btnDistributionNumberSubmit"
        disabled="disabled">{{ 'SHARED.SAVE' | translate }}</button>
      <button type="button" class="btn btn-outline" (click)="onCancel();">{{ 'SHARED.CANCEL' | translate }}</button>
    
        </div>
    </dx-scroll-view>
  </dx-popup>
</div>
